import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 99视频`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
          {video.duration}
        </div>
        <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded">
          {video.quality}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-white text-xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            {video.rating}
          </span>
          <span className="text-foreground-400">{video.source}</span>
        </div>
      </div>
    </Link>
  );
}